export default __webpack_public_path__ + "static/12(1)-3bcfb75cd540645289ea47b8e2a987a9.png";